module.exports = __webpack_public_path__ + "img/13.3a3f5160.jpg";